import React from 'react';
import Picture from '../../components/Shared/Picture';

export default ({ alt, src, children }) => (
  <Picture
    src={`${src}?w=808`}
    alt={alt}
    isResponsive
    sources={[
      {
        media: '(min-width: 1440px)',
        params: '?w=808',
        srcSet: src,
      },
      {
        media: '(min-width: 512px)',
        params: '?w=808',
        srcSet: src,
      },
      {
        media: '(max-width: 512px)',
        params: '?w=808',
        srcSet: src,
      },
    ]}
  >
    {children}
  </Picture>
);
